import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import Form from "./Form";

import { useTopicCategoryContext } from "../../../../contexts/TopicCategoryContext";

export default function ModalForm() {
  const { dispatch, actions, state } = useTopicCategoryContext();

  return (
    <>
      <Modal
        className="student inmodal auto without-overflow"
        show={state.showModal}
        onHide={() => actions.hideModal(dispatch)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {state.currentTopicCategory == null
              ? "Create Topic Category"
              : "Edit Topic Category"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form />
        </Modal.Body>
      </Modal>
    </>
  );
}
